import app from '@/app';
import templateUrl from './iqdTest-detail.html';

/* @ngInject */
function Controller($controller, IqdTest, Road, Plan, ModalService, Principal, $rootScope) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractEntityDetailController', { $ctrl, resource: IqdTest, type: 'iqdTest' });

	$ctrl.modal = () => {
		ModalService.open($ctrl);
	};

	// Default "Sem projeto" (id 0), used to pre-select the required project field.
	$ctrl.defaultProject = () =>
		($ctrl.allProjects || []).find(
			it => it.id === 0 || (it.name && it.name.toLowerCase() === 'sem projeto')
		) || null;

	$ctrl.initProject = () => {
		if (!$ctrl.entity.project) {
			$ctrl.entity.project = $ctrl.defaultProject();
		}
	};

	$ctrl.iqdCalculationSave = () => {
		$ctrl.entity.iqdtype = 'IQDTEST';
		if (!$ctrl.entity.project) {
			$ctrl.entity.project = $ctrl.defaultProject();
		}
		$ctrl.save();
	};

	$ctrl.onOrganizationChange = organization => {
		if (!organization) {
			return;
		}
		$rootScope.isLoadingResults = true;
		Road.query(
			{ sort: 'name,asc', organization: organization.id },
			data => {
				$ctrl.allRoads = data.content;
				$ctrl.loading = false;
				$ctrl.items = $ctrl.buildItems($ctrl.allRoads);
				$rootScope.isLoadingResults = false;
			},
			() => {
				$rootScope.isLoadingResults = false;
			}
		);
	};

	// Rebuilds the display rows from the loaded entity: one row per saved item
	// (so several unifilars on the same road are restored), plus an empty row for
	// roads with no saved item.
	$ctrl.buildItems = roads => {
		let items = [];
		for (let i = 0; i < roads.length; i++) {
			let plansFind = $ctrl.getPlan(roads[i].id, $ctrl.allPlans);
			let savedItems = ($ctrl.entity.items || []).filter(it => it.road.id == roads[i].id);

			if (savedItems.length > 0) {
				savedItems.forEach(saved => {
					let selected = plansFind.find(p => p.id == saved.plan.id) || saved.plan;
					items.push({
						road: roads[i],
						unifilar: { data: plansFind, selected: selected },
						entityItem: saved
					});
				});
			} else {
				items.push({
					road: roads[i],
					unifilar: { data: plansFind, selected: null },
					entityItem: null
				});
			}
		}
		return items;
	};

	$ctrl.getPlan = function(idRoad, plans) {
		let plansFind = [];
		for (let i = 0; i < plans.content.length; i++) {
			if (idRoad == plans.content[i].road.id) {
				plansFind.push(plans.content[i]);
			}
		}
		return plansFind;
	};

	// Unifilars already selected on the road's OTHER display rows (each unifilar can be
	// used only once per road).
	function usedByOtherRows(row) {
		return $ctrl.items
			.filter(r => r !== row && r.road.id === row.road.id && r.unifilar.selected)
			.map(r => r.unifilar.selected.id);
	}

	// Options offered in a row's dropdown: the road's unifilars minus the ones already
	// chosen on the road's other rows. Deleting/clearing a row frees its unifilar, which
	// then reappears here (PDF: the unifilar returns to the list).
	$ctrl.availableUnifilars = row => {
		let used = usedByOtherRows(row);
		return (row.unifilar.data || []).filter(u => used.indexOf(u.id) === -1);
	};

	// The "+" is enabled only when the row has a selection, the road still has an unused
	// unifilar, and there is no pending empty row for that road, so a new inclusion is
	// allowed only after the current segment is filled (PDF: block on the same segment and
	// limit by the unifilars already used).
	$ctrl.canAddUnifilar = row => {
		if ($ctrl.readonly || !row.unifilar.selected) {
			return false;
		}
		let roadRows = $ctrl.items.filter(r => r.road.id === row.road.id);
		let hasEmptyRow = roadRows.some(r => !r.unifilar.selected);
		if (hasEmptyRow) {
			return false;
		}
		let usedCount = roadRows.filter(r => r.unifilar.selected).length;
		return usedCount < (row.unifilar.data || []).length;
	};

	$ctrl.clearUiSelect = function($event, $select, row) {
		$event.stopPropagation();
		$select.selected = null;
		$select.search = null;
		removeEntityItem(row);
	};

	$ctrl.addItem = (data, row) => {
		removeEntityItem(row);
		let newItem = {
			road: { id: data.road.id, name: '' },
			plan: { id: data.id, name: '' }
		};
		$ctrl.entity.items.push(newItem);
		row.entityItem = newItem;
	};

	$ctrl.getSegment = (headMilestone, tailMilestone) => {
		return 'km inicial: ' + headMilestone + ' / ' + 'km final: ' + tailMilestone;
	};

	// Adds an empty row for the same road so the next unifilar can be selected there.
	// Guarded by canAddUnifilar so repeated clicks cannot create extra empty rows.
	$ctrl.duplicateItem = row => {
		if (!$ctrl.canAddUnifilar(row)) {
			return;
		}
		$ctrl.items.push({
			road: row.road,
			unifilar: { data: row.unifilar.data, selected: null },
			entityItem: null
		});
	};

	// Removes a row. A road always keeps at least one row: deleting its last row only clears
	// the selection, so the road stays visible and its unifilar returns to the options list.
	$ctrl.removeItem = (row, $event) => {
		if ($event) {
			$event.stopPropagation();
		}
		removeEntityItem(row);
		let roadRows = $ctrl.items.filter(r => r.road.id === row.road.id);
		if (roadRows.length > 1) {
			$ctrl.items.splice($ctrl.items.indexOf(row), 1);
		} else {
			row.unifilar.selected = null;
		}
	};

	function removeEntityItem(row) {
		if (row.entityItem) {
			let idx = $ctrl.entity.items.indexOf(row.entityItem);
			if (idx > -1) {
				$ctrl.entity.items.splice(idx, 1);
			}
			row.entityItem = null;
		}
	}
}

app.controller('iqdTestDetailController', [
	'$controller',
	'IqdTest',
	'Road',
	'Plan',
	'ModalService',
	'Principal',
	'$rootScope',
	Controller
]);

app.component('iqdTestDetail', {
	templateUrl,
	controller: 'iqdTestDetailController',
	require: {
		parent: '^iqdTestSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<',
		allPlans: '<',
		allProjects: '<'
	}
});
